import classNames from "classnames";
import { FieldState } from "formstate";
import { observer } from "mobx-react";
import React from "react";
import styles from "./checkboxInput.css";

interface Props {
  value: boolean;
  label?: string;
  id: string;
  onChange: (value: boolean) => void;
  smallStyle?: boolean;
  displayNoColors?: boolean;
  noMarginBottom?: boolean;
  className?: string;
}

export const CheckboxInput = ({
  value,
  label = "",
  id,
  onChange,
  smallStyle,
  displayNoColors,
  noMarginBottom,
  className
}: Props) => {
  return (
    <div
      className={classNames(className, styles["checkbox-wrap"], {
        [styles.colors]: displayNoColors !== true,
        [styles.small]: smallStyle,
        [styles["no-margin-bottom"]]: noMarginBottom
      })}
    >
      <label htmlFor={id}>
        <input
          type={"checkbox"}
          checked={value}
          id={id}
          onChange={(ev) => onChange(ev.currentTarget.checked)}
        />
        <div className={classNames(styles.box, { [styles["box-margin-right"]]: !!label })}>
          <span>
            <i className="icon-ok" />
          </span>
        </div>
        {label}
      </label>
    </div>
  );
};

interface PropsFieldState extends Omit<Props, "value" | "onChange"> {
  field: FieldState<boolean>;
}

export const CheckBoxInputFieldState = observer(({ field, ...rest }: PropsFieldState) => {
  return <CheckboxInput onChange={(v) => field.reset(v)} value={field.$} {...rest} />;
});
